.section {
	margin-bottom: 0.75rem;
}

.sectionTitle {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
	color: #374151;
	margin-bottom: 0.5rem;
	padding-bottom: 0.4rem;
	border-bottom: 1px solid #f3f4f6;
}

.sectionIcon {
	color: #6b7280;
	font-size: 16px;
}

.generalGrid {
	display: grid;
	grid-template-columns: repeat(12, minmax(0, 1fr));
	gap: 0.5rem;
}

.programToggle {
	display: inline-flex;
	border: 1px solid #e5e7eb;
	border-radius: 6px;
	overflow: hidden;
	margin-bottom: 0.5rem;
}

.programToggleBtn {
	padding: 6px 16px;
	font-size: 12px;
	font-weight: 500;
	color: #6b7280;
	background: #fff;
	border: none;
	cursor: pointer;
	transition: all 0.15s ease;
	white-space: nowrap;

	&:not(:last-child) {
		border-right: 1px solid #e5e7eb;
	}

	&:hover:not(.programToggleBtnActive) {
		background: #f9fafb;
	}
}

.programToggleBtnActive {
	background: #f0f7e6;
	color: #4a7c11;
	font-weight: 600;
}

.groupsHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 0.5rem;
	padding-bottom: 0.4rem;
	border-bottom: 1px solid #f3f4f6;
}

.groupsTitle {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	color: #374151;
}

.groupsSubtitle {
	font-size: 12px;
	color: #9ca3af;
	font-weight: 400;
}

.groupsList {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.group {
	border: 1px solid #e5e7eb;
	border-radius: 6px;
	padding: 0.5rem 0.75rem;
	background: #fff;
}

.groupHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 0.4rem;
}

.groupActions {
	display: flex;
	align-items: center;
	gap: 6px;
}

.removeGroupBtn {
	background: none;
	border: none;
	cursor: pointer;
	color: #ef4444;
	padding: 4px;
	display: flex;
	align-items: center;
	border-radius: 4px;
	transition: background 0.15s;

	&:hover {
		background: #fef2f2;
	}
}

.productRowsHeader {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 4px 0 6px;
	font-size: 11px;
	color: #9ca3af;
	font-weight: 500;
	text-transform: uppercase;
	letter-spacing: 0.03em;
	border-bottom: 1px solid #f3f4f6;
	margin-bottom: 4px;
}

.alternativeGroup {
	border: 1px dashed #93c5fd;
	border-radius: 6px;
	padding: 0.6rem 0.75rem;
	margin-top: 0.75rem;
	background: #f0f7ff;
}

.alternativeGroupHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 0.5rem;
}

.errorText {
	font-size: 12px;
	color: #ef4444;
	margin-bottom: 0.5rem;
}

.readonlyHeader {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px 12px;
	background: #f9fafb;
	border: 1px solid #e5e7eb;
	border-radius: 6px;
	padding: 8px 12px;
	font-size: 13px;
	color: #111827;
}

.readonlyItem {
	display: flex;
	align-items: center;
	gap: 5px;
}

.readonlyLabel {
	color: #6b7280;
	font-size: 12px;
	white-space: nowrap;
}

.readonlySep {
	color: #d1d5db;
	font-size: 10px;
}

.existingProductsSection {
	margin-bottom: 0.75rem;
	background: #f9fafb;
	border: 1px solid #e5e7eb;
	border-radius: 6px;
	padding: 0.5rem 0.75rem;
}

.existingProductsTitle {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
	color: #374151;
	margin-bottom: 0.4rem;
	padding-bottom: 0.3rem;
	border-bottom: 1px solid #e5e7eb;
}

.existingProductsList {
	display: flex;
	flex-direction: column;
}
